export const buyers = [
  { name: "María González", country: "Mexico", time: "2 minutes ago" },
  { name: "Santiago Rodríguez", country: "Argentina", time: "4 minutes ago" },
  { name: "Valentina López", country: "Colombia", time: "1 minute ago" },
  { name: "Javier Martínez", country: "Spain", time: "6 minutes ago" },
  { name: "Camila Fernández", country: "Chile", time: "3 minutes ago" },
  { name: "Diego Ramírez", country: "Peru", time: "5 minutes ago" },
  { name: "Lucía Torres", country: "Uruguay", time: "2 minutes ago" },
  { name: "Andrés Castillo", country: "Ecuador", time: "7 minutes ago" },
  { name: "Isabella Morales", country: "Costa Rica", time: "1 minute ago" },
  { name: "Mateo Herrera", country: "Dominican Republic", time: "4 minutes ago" },
  { name: "Sofía Vargas", country: "Guatemala", time: "3 minutes ago" },
  { name: "Gabriel Ortega", country: "Paraguay", time: "8 minutes ago" },
  { name: "Daniela Rojas", country: "Bolivia", time: "2 minutes ago" },
  { name: "Alejandro Núñez", country: "Venezuela", time: "5 minutes ago" },
  { name: "Paula Jiménez", country: "Panama", time: "6 minutes ago" },
];
